
import { Component, forwardRef, KeyValueDiffers, Inject, OnChanges, OnInit, ElementRef, ChangeDetectorRef, HostListener, OnDestroy } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';

import { BlockComponent } from '../../../PageBuilder/components/Block/block.component';
import { AbstractPageBuilderService } from '../../../PageBuilder/services/abstract-page-builder.service';
import { ReportsSeriesPreviewService } from '../../../Reports/services/report-series-preview.service';
import { ReportsChartOptionsService } from '../../../Reports/services/reports-chart-options.service';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { MonitorConfigService } from '../../../MonitorShared/services/monitor-config.service';
import { UserPreferencesService } from '../../../../Account/UserPreferences/services/user-preferences.service';
import { ClickOutsideService } from '../../../PageBuilder/services/click-outside.service';
import { ReportsChartDetailService } from '../../../Reports/services/reports-chart-detail.service';
import { SocialChartDetailsDialogService } from '../../../../Social/Intelligence/services/social-chart-details-dialog.service';
import { ConfigService } from '../../../../Core/Config/services/config.service';
import { TopTermChartBlockComponent } from '../../../Reports/components/TopTermChartBlock/top-term-chart-block.component';
import { ChartSizeHelper } from '@Common/Charts/helpers/chart-size.helper';
import { DataConnectionService } from '../../../../Core/Users/services/data-connection.service';
import { ReportsChartSeriesConverterService } from '../../../Reports/services/reports-chart-series-converter.service';
import { ReportsSeriesPreviewNewService } from '../../../../Common/Reports/services/reports-series-preview-new.service';

@Component({
    selector: 'agpr-dashboard-top-term-chart-block',
    templateUrl: './dashboard-top-term-chart-block.component.html',
    styleUrls: ['./dashboard-top-term-chart-block.component.scss'],
    providers: [
        {
            provide: BlockComponent,
            useExisting: forwardRef(() => DashboardTopTermChartBlockComponent)
        }
    ],
    standalone: false
})
export class DashboardTopTermChartBlockComponent extends TopTermChartBlockComponent implements OnChanges, OnInit, OnDestroy {

    constructor(
        public differs: KeyValueDiffers,
        public pageBuilderService: AbstractPageBuilderService,
        public reportSeriesPreviewService: ReportsSeriesPreviewService,
        public reportsChartOptionsService: ReportsChartOptionsService,
        public elementRef: ElementRef,
        public localizationService: LocalizationService,
        @Inject(APP_BASE_HREF) public appBaseHref: string,
        public changeDetectorRef: ChangeDetectorRef,
        public userStateService: CurrentUserStateService,
        public monitorConfigService: MonitorConfigService,
        protected userPreferencesService: UserPreferencesService,
        public clickOutsideService: ClickOutsideService,
        public reportsChartDetailService: ReportsChartDetailService,
        public socialChartDetailsDialogService: SocialChartDetailsDialogService,
        public configService: ConfigService,
        public dataConnectionService: DataConnectionService,
        public reportsChartSeriesConverterService: ReportsChartSeriesConverterService,
        public reportsSeriesPreviewNewService: ReportsSeriesPreviewNewService
    ) {
        super(
            differs,
            pageBuilderService,
            reportSeriesPreviewService,
            reportsChartOptionsService,
            elementRef,
            localizationService,
            appBaseHref,
            changeDetectorRef,
            userStateService,
            monitorConfigService,
            userPreferencesService,
            clickOutsideService,
            reportsChartDetailService,
            socialChartDetailsDialogService,
            configService,
            dataConnectionService,
            reportsChartSeriesConverterService,
            reportsSeriesPreviewNewService
        );
    }
    // we need to add this or else for monitor sources, it will bring you to the page respectively (topics to topics page)
    @HostListener('document:click', ['$event.target']) onClick(event) {
        if (event?.classList?.contains('viewMentionLink')) {
            return false;
        }
    }

    ngOnChanges(): void {
        super.ngOnChanges();
    }
}
